// src/pages/CampaignDashboard/ProspectsTableRow.js

import React from 'react';
import { FaEnvelope, FaLinkedin } from 'react-icons/fa';

const ProspectsTableRow = ({
    prospect,
    isSelected,
    onRowSelect,
    onGenerate,
    onReview,
    onSend,
    onSendLinked,
    getStatusStyle
}) => {
    
    const capitalizeWords = (str) => {
        // ... (capitalizeWords function code)
    };

    const statusInfo = getStatusStyle(prospect.email_confirmation_status_id);

    return (
        <tr>
            <td className="px-6 py-4">
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => onRowSelect(prospect.company_id)}
                />
            </td>
            <td className="px-6 py-4">
                <div className="text-sm font-medium text-gray-900 truncate max-w-[128px]">
                    {capitalizeWords(prospect.company_name)}
                </div>
            </td>
            {/* ... other tds for industry, representative, content ... */}
            <td className="px-6 py-4 whitespace-nowrap">
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${statusInfo.style}`}>
                    {statusInfo.text}
                </span>
            </td>
            {/* ... other tds ... */}
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                <div className="flex space-x-3">
                    <button onClick={() => onGenerate(prospect.company_id)}>Generate</button>
                    <button onClick={() => onReview(prospect.company_id)}>Review</button>
                    <button onClick={() => onSend(prospect.company_id)}><FaEnvelope /></button>
                    <button onClick={() => onSendLinked(prospect.company_id)}><FaLinkedin /></button>
                </div>
            </td>
        </tr>
    );
};

export default ProspectsTableRow;